import React, { useState, useEffect } from 'react'
import { ButtonMedium, style } from 'app/assets/styles'
import { BlazonHexagonBorder } from 'app/common/blazon/hexagon-border/BlazonHexagonBorder'
import { H5, Text } from 'app/common/typography'
import { FormattedMessage, useIntl } from 'react-intl'
import { colors } from 'shared/assets/styles'
import type { Blazon } from 'shared/types'
import styled from 'styled-components'
import { Button } from 'app/assets/styles'
import { SmallText } from 'app/common/typography'
import Modal from 'react-modal'
import { DeleteModal } from 'app/common/modals'
import { deleteBlazon } from 'shared/store/kingdom/blazons'
import { useDispatch, useSelector } from 'react-redux'

const { yellow, grey, red } = colors

type Props = {
    blazon: Blazon,
    onClick: () => void,
    disabled?: boolean,
    isButtonAlignedRight?: boolean
}

const BlazonCardContent = (props: Props) => {
    const [openDeleteBlazonModal, setOpenDeleteBlazonModal] = useState(false)
    const dispatch = useDispatch()
    const intl = useIntl()

    const {
        blazon,
        onClick,
        disabled = false,
        isButtonAlignedRight = false
    } = props

    const { title, description, imageUrl } = blazon

    const closeDeleteBlazonModal = () => {
        setOpenDeleteBlazonModal(false)
    }

    const deleteBlazonById = () => {
        dispatch({
            type: 'PAGE_DATA_BLAZONS_RESPONSE',
            data: { blazons: null, error: false }
        })
        deleteBlazon(blazon.id)(dispatch)
    }

    return (
        <Container>
            <Body>
                <ImageContainer>
                    <BlazonHexagonBorder
                        src={imageUrl}
                        disabled={disabled}
                        small
                    />
                </ImageContainer>
                <StyledMiddleContainer>
                    <Title disabled={disabled}>{title}</Title>
                    <Description>{description}</Description>
                </StyledMiddleContainer>
                <StyledRightContainer>
                    <Button
                        onClick={() => {
                            setOpenDeleteBlazonModal(true)
                        }}>
                        <SmallText underline>
                            {intl.formatMessage({ id: 'delete' })}
                        </SmallText>
                    </Button>
                    <Modal
                        isOpen={openDeleteBlazonModal}
                        ariaHideApp={false}
                        style={style.classicModalStyle}>
                        <DeleteModal
                            handleClose={closeDeleteBlazonModal}
                            handleDelete={deleteBlazonById}
                            messageKey="kingdom.blazons.delete"
                        />
                    </Modal>
                </StyledRightContainer>
            </Body>
            <ButtonMediumAligned
                type="button"
                background={yellow}
                border={yellow}
                onClick={onClick}
                isButtonAlignedRight={isButtonAlignedRight}>
                <FormattedMessage id="learn.more" />
            </ButtonMediumAligned>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: space-between;
    height: fit-content;
`

const StyledRightContainer = styled.div`
    align-self: flex-start;
    margin-left: auto;
`

const Body = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 26px;
    width: 100%;
    height: 100%;
`

const Title = styled(H5)`
    ${({ disabled }) => disabled && `color: ${grey}`}}
`

const Description = styled(Text)`
    color: ${grey};
`

const ImageContainer = styled.div`
    min-width: 30%;
    height: auto;
    max-height: 100%;
`

const ButtonMediumAligned = styled(ButtonMedium)`
    align-self: ${({ isButtonAlignedRight }) =>
        isButtonAlignedRight ? 'flex-end' : 'stretch'};
`

const StyledMiddleContainer = styled.div`
    max-width: 100px;
`

export { BlazonCardContent }
